import { gql } from "@apollo/client";

export const newSiteCheckpointMutation = gql`
mutation($input: SiteCheckpointInput!){
  newSiteCheckpoint(input: $input) {
    message
    response
  }
}
`;

export const updateSiteCheckpointMutation = gql`
mutation($input: SiteCheckpointInput!){
  updateSiteCheckpoint(input: $input) {
    message
    response
  }
}
`;

export const deleteSiteCheckpointMutation = gql`
mutation($checkpointId: String!){
  deleteSiteCheckpoint(checkpointId: $checkpointId) {
    message
    response
  }
}
`;

export const regenerateCheckpointQrMutation = gql`
mutation($checkpointId: String!){
  regenerateCheckpointQr(checkpointId: $checkpointId) {
    message
    response
  }
}
`;

export const assignNfcTagMutation = gql`
mutation($checkpointId: String!, $nfcTagId: String!){
  assignNfcTag(checkpointId: $checkpointId, nfcTagId: $nfcTagId) {
    message
    response
  }
}
`;

export const removeNfcTagMutation = gql`
mutation($checkpointId: String!){
  removeNfcTag(checkpointId: $checkpointId) {
    message
    response
  }
}
`;

export const updateCheckpointGeofencingMutation = gql`
mutation($input: CheckpointGeofencingInput!){
  updateCheckpointGeofencing(input: $input) {
    message
    response
  }
}
`;
